
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.535 9.879l-5.657 5.657-1.414-1.414 5.657-5.657 1.414 1.414z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.95 7.05a3 3 0 00-4.243 0l-1.414 1.415L9.878 7.05l1.415-1.415a5 5 0 017.07 7.071l-1.413 1.415-1.415-1.415 1.415-1.414a3 3 0 000-4.242zM7.05 16.95a3 3 0 004.243 0l1.414-1.414 1.414 1.414-1.414 1.414a5 5 0 01-7.071-7.07L7.05 9.878l1.414 1.414-1.414 1.414a3 3 0 000 4.243z"}})])
          )
        }
      }
    